module.exports = __webpack_public_path__ + "img/credit-card.176c4ab0.gif";